// @flow

import { useState, useCallback, useEffect } from 'react';

import { type UserInputName } from '../user-input';
import { useUserInputValue } from './use-user-input-value';

export type FormatRaw = (rawValue: string) => string;
export type ParseFormatted = (formattedValue: string) => string;

export function useUserInputValueWithFormatting(
  name: UserInputName,
  formatRaw: FormatRaw,
  parseFormatted: ParseFormatted,
): [string, (newValue: string) => void] {
  const [rawValue, setRawValue] = useUserInputValue(name);
  const [formattedValue, setFormattedValue] = useState(rawValue);

  useEffect(() => {
    setFormattedValue(formatRaw(rawValue));
  }, [formatRaw, rawValue]);

  const value = formattedValue;
  const setValue = useCallback(
    (newFormattedValue: string) => {
      setRawValue(parseFormatted(newFormattedValue));
      setFormattedValue(newFormattedValue);
    },
    [setRawValue, parseFormatted],
  );

  return [value, setValue];
}
